import { Injectable, Injector } from "@angular/core";
import {
  Auth,
  authState,
  signInWithEmailAndPassword,
  signOut,
  User,
} from "@angular/fire/auth";
import { Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { ALERT_TYPE, AlertService } from "../common/services/alert.service";
import { SettingsService } from "../common/services/settings.service";

@Injectable({ providedIn: "root" })
export class LoginService {
  public user$: Observable<User | null>;
  public authUID: string | undefined;

  constructor(
    private auth: Auth,
    private router: Router,
    private alertService: AlertService,
    private injector: Injector
  ) {
    this.user$ = authState(this.auth).pipe(
      tap(async (user) => {
        if (user) {
          this.authUID = user.uid;
          /** injetando o serviço de settings lazily */
          const settingsService = this.injector.get(SettingsService);
        } else {
          this.authUID = undefined;
        }
      })
    );
  }

  async loginUser(email: string, password: string): Promise<void> {
    try {
      const userInfo = await signInWithEmailAndPassword(
        this.auth,
        email,
        password
      );
      this.authUID = userInfo.user.uid;
      /** aguarda até o estado de autenticação é estabilizado */
      await new Promise((resolve) => setTimeout(resolve, 1000));

      /** seta as configurações do usuário */
      const settingsService = this.injector.get(SettingsService);
      await settingsService.getUserSettings();

      setTimeout(() => {
        const isFirstAccess = localStorage.getItem("isFirstAccess");

        if (isFirstAccess && JSON.parse(isFirstAccess) === false) {
          this.router.navigate(["/tabs/tab1"]);
        } else {
          this.router.navigate(["/welcome"]);
        }
      }, 100);
    } catch (error) {
      console.error("Login failed:", error);
      await this.alertService.showAlert(
        ALERT_TYPE.ERROR,
        "COMMON.ALERTS.badLogin"
      );
    }
  }

  async logout(): Promise<void> {
    try {
      await signOut(this.auth);
      this.authUID = undefined;
      /** injetando o serviço de settings lazily */
      const settingsService = this.injector.get(SettingsService);
      settingsService.SETTINGS = undefined;
      settingsService.PLAN = undefined;
      settingsService.IS_CONTRACT_VALID = false;

      sessionStorage.clear();

      setTimeout(() => {
        window.location.href = "/login";
      }, 100);
    } catch (error) {
      console.error("Logout failed:", error);
      await this.alertService.showAlert(
        ALERT_TYPE.ERROR,
        "COMMON.ALERTS.logoutFailed"
      );
    }
  }
}
